import React from 'react'
import PageTitleAndSnackBar from '../../components/common/PageTitleAndSnackBar'

const Faq = () => {
  return (
    <>


<PageTitleAndSnackBar pageTitle="FAQ" />

      {/* <!-- End Page Title --> */}

      <section class="section faq">
        <div class="row">
          <div class="col-lg-6">

            <div class="card basic">
              <div class="card-body">
                <h5 class="card-title">Getting Started</h5>

                <div>
                  <h6>1. How do I register as a flight supplier?</h6>
                  <p>To register as a flight supplier, click on the "Sign Up" button and fill in your company details including airline information, contact details, and business registration documents. Once submitted, our team will review and approve your account within 24-48 hours.</p>
                </div>

                <div class="pt-2">
                  <h6>2. What documents do I need to provide during registration?</h6>
                  <p>You'll need to provide your business registration certificate, airline operator license, tax identification number, and authorized signatory documents. All documents should be current and valid.</p>
                </div>

                <div class="pt-2">
                  <h6>3. How long does the approval process take?</h6>
                  <p>The approval process typically takes 24-48 hours after all required documents are submitted and verified. You'll receive an email notification once your account is approved and activated.</p>
                </div>

              </div>
            </div>

            {/* <!-- F.A.Q Group 1 --> */}
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">Inventory Management</h5>

                <div class="accordion accordion-flush" id="faq-group-1">

                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button class="accordion-button collapsed" data-bs-target="#faqsOne-1" type="button"
                        data-bs-toggle="collapse">
                        How do I add flight inventory to the system?
                      </button>
                    </h2>
                    <div id="faqsOne-1" class="accordion-collapse collapse" data-bs-parent="#faq-group-1">
                      <div class="accordion-body">
                        You can add flight inventory through two methods: individual flight entry via the "Add Flight" form, or bulk upload using our CSV template. For bulk uploads, download the sample CSV file, fill in your flight details, and upload it through the "Bulk Upload" feature.
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button class="accordion-button collapsed" data-bs-target="#faqsOne-2" type="button"
                        data-bs-toggle="collapse">
                        Can I update flight prices and availability in real-time?
                      </button>
                    </h2>
                    <div id="faqsOne-2" class="accordion-collapse collapse" data-bs-parent="#faq-group-1">
                      <div class="accordion-body">
                        Yes, you can update flight prices, seat availability, and flight status in real-time through the inventory management dashboard. Changes are immediately reflected in the booking system and visible to travel agents and customers.
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button class="accordion-button collapsed" data-bs-target="#faqsOne-3" type="button"
                        data-bs-toggle="collapse">
                        What information is required for each flight entry?
                      </button>
                    </h2>
                    <div id="faqsOne-3" class="accordion-collapse collapse" data-bs-parent="#faq-group-1">
                      <div class="accordion-body">
                        Each flight entry requires: airline code, flight number, departure/arrival airports, departure/arrival times, aircraft type, seat capacity by class, pricing for different fare types, baggage allowances, and any special conditions or restrictions.
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button class="accordion-button collapsed" data-bs-target="#faqsOne-4" type="button"
                        data-bs-toggle="collapse">
                        How can I manage seasonal pricing and special offers?
                      </button>
                    </h2>
                    <div id="faqsOne-4" class="accordion-collapse collapse" data-bs-parent="#faq-group-1">
                      <div class="accordion-body">
                        The system supports date-based pricing rules, promotional codes, and seasonal adjustments. You can set different price tiers for peak/off-peak seasons, create limited-time offers, and apply bulk pricing changes across multiple flights.
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button class="accordion-button collapsed" data-bs-target="#faqsOne-5" type="button"
                        data-bs-toggle="collapse">
                        Can I set booking restrictions and advance purchase requirements?
                      </button>
                    </h2>
                    <div id="faqsOne-5" class="accordion-collapse collapse" data-bs-parent="#faq-group-1">
                      <div class="accordion-body">
                        Yes, you can configure advance booking requirements, minimum/maximum stay restrictions, refund policies, change fees, and other booking conditions for each fare type. These rules are automatically enforced during the booking process.
                      </div>
                    </div>
                  </div>

                </div>

              </div>
            </div>
            {/* <!-- End F.A.Q Group 1 --> */}

          </div>

          <div class="col-lg-6">

            {/* <!-- F.A.Q Group 2 --> */}
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">Bookings & Payments</h5>

                <div class="accordion accordion-flush" id="faq-group-2">

                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button class="accordion-button collapsed" data-bs-target="#faqsTwo-1" type="button"
                        data-bs-toggle="collapse">
                        How do I track and manage bookings made by travel agents?
                      </button>
                    </h2>
                    <div id="faqsTwo-1" class="accordion-collapse collapse" data-bs-parent="#faq-group-2">
                      <div class="accordion-body">
                        The booking management dashboard provides real-time visibility of all reservations with detailed passenger information, payment status, and booking references. You can filter by date, route, agent, or booking status to easily track and manage your bookings.
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button class="accordion-button collapsed" data-bs-target="#faqsTwo-2" type="button"
                        data-bs-toggle="collapse">
                        What payment methods are supported for agent bookings?
                      </button>
                    </h2>
                    <div id="faqsTwo-2" class="accordion-collapse collapse" data-bs-parent="#faq-group-2">
                      <div class="accordion-body">
                        The platform supports multiple payment options including credit cards, bank transfers, digital wallets, and credit facilities for approved agents. You can configure payment terms and credit limits for different agent partners based on your business agreements.
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button class="accordion-button collapsed" data-bs-target="#faqsTwo-3" type="button"
                        data-bs-toggle="collapse">
                        How are commission payments handled for travel agents?
                      </button>
                    </h2>
                    <div id="faqsTwo-3" class="accordion-collapse collapse" data-bs-parent="#faq-group-2">
                      <div class="accordion-body">
                        Commission structures can be set per agent or route, with automatic calculation and tracking. The system generates detailed commission reports and handles payment processing based on your configured settlement schedule (weekly, monthly, or per booking).
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button class="accordion-button collapsed" data-bs-target="#faqsTwo-4" type="button"
                        data-bs-toggle="collapse">
                        Can I handle booking modifications and cancellations?
                      </button>
                    </h2>
                    <div id="faqsTwo-4" class="accordion-collapse collapse" data-bs-parent="#faq-group-2">
                      <div class="accordion-body">
                        Yes, the system supports booking changes, cancellations, and refund processing according to your fare rules. You can approve or reject change requests, process refunds, and automatically apply applicable fees and penalties based on your policy settings.
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button class="accordion-button collapsed" data-bs-target="#faqsTwo-5" type="button"
                        data-bs-toggle="collapse">
                        How do I handle group bookings and special requests?
                      </button>
                    </h2>
                    <div id="faqsTwo-5" class="accordion-collapse collapse" data-bs-parent="#faq-group-2">
                      <div class="accordion-body">
                        The platform supports group booking management with special pricing, seat blocking, and custom terms. Special service requests like meals, wheelchairs, and unaccompanied minors can be tracked and managed through the booking details section.
                      </div>
                    </div>
                  </div>

                </div>

              </div>
            </div>
            {/* <!-- End F.A.Q Group 2 --> */}

            {/* <!-- F.A.Q Group 3 --> */}
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">Reports & Analytics</h5>

                <div class="accordion accordion-flush" id="faq-group-3">

                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button class="accordion-button collapsed" data-bs-target="#faqsThree-1" type="button"
                        data-bs-toggle="collapse">
                        What types of reports are available for flight suppliers?
                      </button>
                    </h2>
                    <div id="faqsThree-1" class="accordion-collapse collapse" data-bs-parent="#faq-group-3">
                      <div class="accordion-body">
                        The platform provides comprehensive reporting including booking summaries, revenue analysis, load factor reports, agent performance metrics, route profitability analysis, and inventory utilization reports. All reports can be filtered by date range, route, or agent.
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button class="accordion-button collapsed" data-bs-target="#faqsThree-2" type="button"
                        data-bs-toggle="collapse">
                        How can I monitor my flight performance and revenue?
                      </button>
                    </h2>
                    <div id="faqsThree-2" class="accordion-collapse collapse" data-bs-parent="#faq-group-3">
                      <div class="accordion-body">
                        The dashboard provides real-time analytics with key performance indicators including occupancy rates, average selling price, revenue per flight, booking trends, and comparison with previous periods. Visual charts and graphs make it easy to identify patterns and opportunities.
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button class="accordion-button collapsed" data-bs-target="#faqsThree-3" type="button"
                        data-bs-toggle="collapse">
                        Can I export booking data for external analysis?
                      </button>
                    </h2>
                    <div id="faqsThree-3" class="accordion-collapse collapse" data-bs-parent="#faq-group-3">
                      <div class="accordion-body">
                        Yes, all reports and booking data can be exported in various formats including CSV, Excel, and PDF. You can schedule automated report generation and delivery via email, or access data through API endpoints for integration with your existing systems.
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button class="accordion-button collapsed" data-bs-target="#faqsThree-4" type="button"
                        data-bs-toggle="collapse">
                        How do I track agent commissions and payments?
                      </button>
                    </h2>
                    <div id="faqsThree-4" class="accordion-collapse collapse" data-bs-parent="#faq-group-3">
                      <div class="accordion-body">
                        The commission tracking module provides detailed reports on agent earnings, payment schedules, outstanding balances, and commission reconciliation. You can generate agent statements, track payment history, and manage credit limits all from one dashboard.
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button class="accordion-button collapsed" data-bs-target="#faqsThree-5" type="button"
                        data-bs-toggle="collapse">
                        Are there any API integrations available for data synchronization?
                      </button>
                    </h2>
                    <div id="faqsThree-5" class="accordion-collapse collapse" data-bs-parent="#faq-group-3">
                      <div class="accordion-body">
                        Yes, we provide RESTful APIs for inventory management, booking creation, real-time availability checks, and reporting. You can integrate with your existing reservation systems, accounting software, or business intelligence tools to synchronize data seamlessly.
                      </div>
                    </div>
                  </div>

                </div>

              </div>
            </div>
            {/* <!-- End F.A.Q Group 3 --> */}

          </div>

        </div>
      </section>


    </>
  )
}

export default Faq